import { 
  PieChart as PChart,
  Cell,Pie,
Tooltip, Legend
} from 'recharts';
import { useTheme } from 'styled-components';
import {getPieBarColor} from './utils';
import {formatCellValue} from './utils';

export const PieChart = ({commonProps,data, widget }:any) =>{

    const theme = useTheme();
    const baseField = widget.percentageBase; // Configurable base
    const baseEntry = baseField ? data.find((d: any) => d.name === baseField) : null;
    const baseValue = baseEntry?.amount || null;

    // Calculate percentages relative to base
    const pieData = baseValue
    ? data.map((entry: any) => ({
        ...entry,
        displayAmount: Math.abs(entry.amount),
        relativePercent: (Math.abs(entry.amount) / Math.abs(baseValue)) * 100,
        }))
    : data.map((entry: any) => ({
        ...entry,
        displayAmount: Math.abs(entry.amount),
        }));
    
    const renderLabel = (props: any) => {
        const {percent} = props;
        if ((percent * 100) < 1) return null;
        return (
            `${(percent * 100).toFixed(1)}%`
        );
        };

    return (
        <PChart > 
            <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={50}
                label={renderLabel}
                fill="#8884d8"
                dataKey={Array.isArray(widget.dataKey) ? widget.dataKey[0] : widget.valueKey}
            >
             {pieData.map((entry:any, index:any) => (
                <Cell key={`cell-${index}`} fill={getPieBarColor(widget.valueKey,entry,widget.fields,index)} />
              ))}
            </Pie>
            <Tooltip 
                formatter={(value:any) => [
                formatCellValue(value, widget.isPricing === true), 
                null  // Hide the series name (amount)
                ]}
                itemStyle={{ 
                  color: theme.darkMode ? '#58a6ff' : '#007bff',
                  fontSize: '12px',
                  paddingTop: '4px'
                }}
                labelFormatter={(label) => label} 
                contentStyle={{ 
                background: theme.darkMode ? '#1a1a1a' : 'white', 
                borderRadius: '8px',
                }} 
            />
            <Legend 
                layout="horizontal" 
                verticalAlign="bottom" 
                align="right"
                iconType="circle"
                wrapperStyle={{
                    fontSize: "12px"
                }}
                />
        </PChart>
    )

}